import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './programas.css';
import { programas_item,programas_item2 } from '../../json/programasItem';

const Programas = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container programas-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='programas_title'>
                        <h1>Programas Alternativos</h1>
                    </div>
                </div>
            </div>

            <div className='row' >
                {
                    programas_item2.map((item, index) => (
                        <div key={index} className='programas_item'>
                               <a href={item.url} target="_blank" >{item.nombre}
                                   <div className='programas_container'>
                                   <div className='programas_icono'>
                                       <img src={"/assets/imgs/" + item.icono} alt=''/>
                                   </div>
                               </div>
                               <br></br>
                               <h5>{item.programas_item_nombre}</h5>
                               </a>
                        </div>
                     
                    ))
                }
            </div>
            <br></br>
            <div className='row'>
                        {
                        programas_item.map((item, index)=>(
                            <Link key={index} to={item.programas_item_url} 
                            className='col-md-4 col-sm-6 col-12 programas_enlace'>
                            <div className='programas_container'>
                                <div className='programas_icono'>
                                <img src={"/assets/imgs/" + item.icono} alt=''/>
                                </div>
                                <a>{ item.programas_item_nombre }</a>
                            </div>
                            </Link>
                        ))
                        }
            </div> 
        </div>
    )
}

export default Programas